import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { $ } from '../../../base/browser/dom.js';
import { isEmptyMarkdownString } from '../../../base/common/htmlContent.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { HoverOperation } from './hoverOperation.js';
import { GlyphHoverWidget } from './hoverWidgets.js';
import { MarkdownRenderer } from '../markdown/markdownRenderer.js';
import { NullOpenerService } from '../../../platform/opener/common/opener.js';
import { asArray } from '../../../base/common/arrays.js';

var MarginComputer = /*#__PURE__*/function () {
  function MarginComputer(editor) {
    _classCallCheck(this, MarginComputer);

    this._editor = editor;
    this._lineNumber = -1;
    this._result = [];
  }

  _createClass(MarginComputer, [{
    key: "setLineNumber",
    value: function setLineNumber(lineNumber) {
      this._lineNumber = lineNumber;
      this._result = [];
    }
  }, {
    key: "clearResult",
    value: function clearResult() {
      this._result = [];
    }
  }, {
    key: "computeSync",
    value: function computeSync() {
      var toHoverMessage = function toHoverMessage(contents) {
        return {
          value: contents
        };
      };

      var lineDecorations = this._editor.getLineDecorations(this._lineNumber);

      var result = [];

      if (!lineDecorations) {
        return result;
      }

      var _iterator = _createForOfIteratorHelper(lineDecorations),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var d = _step.value;

          if (!d.options.glyphMarginClassName) {
            continue;
          }

          var hoverMessage = d.options.glyphMarginHoverMessage;

          if (!hoverMessage || isEmptyMarkdownString(hoverMessage)) {
            continue;
          }

          result.push.apply(result, _toConsumableArray(asArray(hoverMessage).map(toHoverMessage)));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
  }, {
    key: "onResult",
    value: function onResult(result, isFromSynchronousComputation) {
      this._result = this._result.concat(result);
    }
  }, {
    key: "getResult",
    value: function getResult() {
      return this._result;
    }
  }, {
    key: "getResultWithLoadingMessage",
    value: function getResultWithLoadingMessage() {
      return this.getResult();
    }
  }]);

  return MarginComputer;
}();

export var ModesGlyphHoverWidget = /*#__PURE__*/function (_GlyphHoverWidget) {
  _inherits(ModesGlyphHoverWidget, _GlyphHoverWidget);

  var _super = _createSuper(ModesGlyphHoverWidget);

  function ModesGlyphHoverWidget(editor, modeService) {
    var _this;

    var openerService = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NullOpenerService;

    _classCallCheck(this, ModesGlyphHoverWidget);

    _this = _super.call(this, ModesGlyphHoverWidget.ID, editor);
    _this._renderDisposeables = _this._register(new DisposableStore());
    _this._messages = [];
    _this._lastLineNumber = -1;
    _this._markdownRenderer = _this._register(new MarkdownRenderer(_this._editor, modeService, openerService));
    _this._computer = new MarginComputer(_this._editor);
    _this._hoverOperation = new HoverOperation(_this._computer, function (result) {
      return _this._withResult(result);
    }, undefined, function (result) {
      return _this._withResult(result);
    }, 300);
    return _this;
  }

  _createClass(ModesGlyphHoverWidget, [{
    key: "dispose",
    value: function dispose() {
      this._hoverOperation.cancel();

      _get(_getPrototypeOf(ModesGlyphHoverWidget.prototype), "dispose", this).call(this);
    }
  }, {
    key: "onModelDecorationsChanged",
    value: function onModelDecorationsChanged() {
      if (this.isVisible) {
        // The decorations have changed and the hover is visible,
        // we need to recompute the displayed text
        this._hoverOperation.cancel();

        this._computer.clearResult();

        this._hoverOperation.start(0
        /* Delayed */
        );
      }
    }
  }, {
    key: "startShowingAt",
    value: function startShowingAt(lineNumber) {
      if (this._lastLineNumber === lineNumber) {
        // We have to show the widget at the exact same line number as before, so no work is needed
        return;
      }

      this._hoverOperation.cancel();

      this.hide();
      this._lastLineNumber = lineNumber;

      this._computer.setLineNumber(lineNumber);

      this._hoverOperation.start(0
      /* Delayed */
      );
    }
  }, {
    key: "hide",
    value: function hide() {
      this._lastLineNumber = -1;

      this._hoverOperation.cancel();

      _get(_getPrototypeOf(ModesGlyphHoverWidget.prototype), "hide", this).call(this);
    }
  }, {
    key: "_withResult",
    value: function _withResult(result) {
      this._messages = result;

      if (this._messages.length > 0) {
        this._renderMessages(this._lastLineNumber, this._messages);
      } else {
        this.hide();
      }
    }
  }, {
    key: "_renderMessages",
    value: function _renderMessages(lineNumber, messages) {
      this._renderDisposeables.clear();

      var fragment = document.createDocumentFragment();

      var _iterator2 = _createForOfIteratorHelper(messages),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var msg = _step2.value;

          var renderedContents = this._markdownRenderer.render(msg.value);

          this._renderDisposeables.add(renderedContents);

          fragment.appendChild($('div.hover-row', undefined, renderedContents.element));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.updateContents(fragment);
      this.showAt(lineNumber);
    }
  }]);

  return ModesGlyphHoverWidget;
}(GlyphHoverWidget);
ModesGlyphHoverWidget.ID = 'editor.contrib.modesGlyphHoverWidget';